<template>
    <v-container>
        <v-row
                class="d-flex justify-center"
        >

            <v-dialog
                    v-model="show"
                    :width="loading ? 250 : width"
                    :persistent="!closable"
                    @click:outside="$emit('outsideClick')"
            >

                <v-card v-if="loading">
                    <v-card-text class="text-center d-flex flex-column justify-center align-center">
                        <img :src="require('@/../public/media/bg/ترمینال.png')" alt="" class="img-fluid">
                        <atom-spinner
                                class="spine mt-5"
                                :animation-duration="2500"
                                :size="80"
                                color="indigo"
                        />

                        <p class="font-weight-bold font-size-h4 pt-4 pb-0 mb-0">
                            {{ i18n.t('Loading.Waiting') }} ...
                        </p>
                        <div>

                        </div>
                    </v-card-text>
                    <!--          <p class="text-center mb-0 description">{{i18n.t('Loading.Description')}}</p>-->
                    <!--          <v-divider class="my-0 py-0"></v-divider>-->

                    <v-card-actions class="d-flex justify-center">

                        <!--            <hollow-dots-spinner-->
                        <!--                :animation-duration="1000"-->
                        <!--                :dot-size="15"-->
                        <!--                :dots-num="3"-->
                        <!--                color="#8b8e94"-->

                        <!--            />-->
                        <!--          color="#ff1d5e"-->
                        <!--          <p class="text-center">کور لند</p>-->
                    </v-card-actions>
                </v-card>

                <v-card v-else>
                    <slot/>
                </v-card>

            </v-dialog>

        </v-row>
    </v-container>


</template>

<script>
import {AtomSpinner, HalfCircleSpinner, HollowDotsSpinner} from 'epic-spinners'
import i18n from "../../i18n";

export default {
    name: "WaitStatusDialog",
    components: {HollowDotsSpinner, HalfCircleSpinner, AtomSpinner},
    props: {
        show: {
            type: false,
            default: false
        },
        closable: true,
        loading: {
            type: Boolean,
            default: true
        },
        width: {
            default: 500
        }
    },
    data() {
        return {
            i18n
        }
    },
    watch: {
        show(n, o) {
            this.$emit("onShowChange", n)
        }
    }
}
</script>

<style scoped>
.description {
    font-size: 0.7rem;
    color: darkgray;
}

.spine {
    animation: spin 3s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>